export default __webpack_public_path__ + "static/media/HydroSight_v1.80f1ddc8.webp";